export default __webpack_public_path__ + "static/lessen-quote-banner-cb362c8c1ac65c5165b1b03ce475e400.jpg";